export enum WHATSAPP_CHALLAN_PAGE_TYPE {
  SCANNING_LOADER = 'SCANNING_LOADER',
  FINAL_PAGE = 'FINAL_PAGE',
}

export enum WHATSAPP_CHALLAN_JOURNEY {
  ULIP_SKIPPED = 'ULIP_SKIPPED',
  ULIP_CHECKED = 'ULIP_CHECKED',
}

export enum StatusType {
  COMPLETE = 'complete',
  REQUIRES_APP = 'requiresApp',
}

export enum ChallansStatus {
  EMPTY = 'empty',
  SOME = 'some',
  DEFAULT = 'nonVahan',
}

export enum LOADER_VARIANT {
  VARIANT_1 = 'variant_1',
  VARIANT_2 = 'variant_2',
  VARIANT_3 = 'variant_3',
}
